// Site-wide footer with the legal links. California's privacy law (CalOPPA)
// expects the privacy policy to be linked conspicuously from the site, not
// only from the signup form.
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { LEGAL_CONTACT } from "../utils/legal";

// Full-height screens where a footer would get in the way, and the
// standalone portfolio, which has its own footer.
const HIDDEN_ON = [/^\/messages\//, /^\/yard-office/, /^\/portfolio/, /^\/adams-projects/];

export default function SiteFooter() {
  const { pathname } = useLocation();
  if (HIDDEN_ON.some((re) => re.test(pathname))) return null;
  return (
    <footer className="bg-brand-ink border-t border-white/10 pb-24 lg:pb-0">
      <div className="max-w-6xl mx-auto px-4 py-5 flex flex-wrap items-center justify-between gap-3 text-xs text-slate-400">
        <span>© {new Date().getFullYear()} Jale · California</span>
        <nav className="flex flex-wrap gap-4">
          <Link to="/terms" className="hover:text-brand-yellow">Terms</Link>
          <Link to="/privacy" className="hover:text-brand-yellow">Privacy</Link>
          <a href={`mailto:${LEGAL_CONTACT}`} className="hover:text-brand-yellow">{LEGAL_CONTACT}</a>
        </nav>
      </div>
    </footer>
  );
}
